import styled from "styled-components";
import {
  Dialog,
  DialogScroll,
  DialogTitle,
} from "discover.medical.react-component-library";

export const StyledContributorWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.space.md};
`;

export const StyledDialog = styled(Dialog)`
  & > * {
    max-width: 750px;
  }
`;

export const StyledDialogTitle = styled(DialogTitle)`
  padding-left: ${({ theme }) => theme.space.xl};
  padding-top: ${({ theme }) => theme.space.xl};
`;

export const StyledDialogScroll = styled(DialogScroll)`
  padding: 0 ${({ theme }) => theme.space.xl};
  padding-bottom: ${({ theme }) => theme.space.xl};
`;
